module.exports = __webpack_public_path__ + "static/media/stop-share-screen.e9889a6c.svg";